import { SectionHeaderRowSpaceBetweenNoBorder } from '@ydistri/ds';
import React, { useMemo } from 'react';
import MenuSubpages from '../../../components/menu/MenuSubpages';
import { RoutingPage, RoutingSubpage } from '../../../routes/routerSlice';
import { ProjectAdministrationSubpage } from '../projectAdministrationLib';
import useSubpage from '../../../hooks/useSubpage';
import { getEntityListSpecification } from '../EntityListAdministration/entityListsLib';
import { EntityListTypeName } from '@ydistri/api-sdk';
import { useApplicationConfiguration } from '../../../hooks/useApplicationConfiguration';
import { SubmenuOption } from '../../Configuration/ConfigurationHeader';
import { YPICK_LABEL } from '../../../components/global/_constants';

const getMenuOptions = (
  isYPickEnabled: boolean,
  selectedSubpage: RoutingSubpage | undefined,
): SubmenuOption[] => {
  if (selectedSubpage === ProjectAdministrationSubpage.SCOPE) return [];

  const entityListMenuItemsOrder: EntityListTypeName[] = [
    EntityListTypeName.Product,
    EntityListTypeName.Request,
    EntityListTypeName.MinLayer,
    EntityListTypeName.Source,
    EntityListTypeName.Target,
    EntityListTypeName.Forced,
  ];

  const subpageGroups: SubmenuOption[][] = [];

  const menuItems = entityListMenuItemsOrder.map(type => {
    const specification = getEntityListSpecification(type);
    return {
      value: specification.subpage,
      label: specification.menuOptionTitle,
    };
  });
  subpageGroups.push(menuItems);

  if (isYPickEnabled) {
    subpageGroups.push([
      {
        value: ProjectAdministrationSubpage.YPICK_CREDENTIALS,
        label: `${YPICK_LABEL} credentials`,
      },
    ]);
  }

  subpageGroups.push([
    {
      value: ProjectAdministrationSubpage.STORES_SCHEDULE,
      label: 'Stores schedule',
    },
  ]);

  subpageGroups.push([
    {
      value: ProjectAdministrationSubpage.AI_PROMPTS,
      label: 'AI Prompts',
    },
  ]);

  const selectedSubpageGroup = subpageGroups.find(group =>
    group.find(option => option.value === selectedSubpage),
  );

  return selectedSubpageGroup ?? [];
};

/**
 * Contains navigation to subpages within Administration part of the app.
 */
const AdministrationHeader: React.FC = () => {
  const { isPickAndPackEnabled } = useApplicationConfiguration();
  const subpage = useSubpage();

  //TODO 1 - remove, endpoint doesnt work at this time but will be fixed
  //TODO 2 - change let to const (above)
  // isPickAndPackEnabled = true;
  const menuOptions = useMemo(
    () => getMenuOptions(isPickAndPackEnabled, subpage),
    [isPickAndPackEnabled, subpage],
  );

  if (menuOptions.length === 0) {
    return null;
  }

  return (
    <SectionHeaderRowSpaceBetweenNoBorder>
      <MenuSubpages
        routingPage={RoutingPage.PROJECT_ADMINISTRATION}
        submenuOptions={menuOptions}
        selectedOption={subpage}
      />
    </SectionHeaderRowSpaceBetweenNoBorder>
  );
};

export default AdministrationHeader;
